import { render, staticRenderFns } from "./FiscalizacaoIrregularidadesAssociadas.vue?vue&type=template&id=6693e5ab&"
import script from "./FiscalizacaoIrregularidadesAssociadas.vue?vue&type=script&lang=js&"
export * from "./FiscalizacaoIrregularidadesAssociadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports